var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBelow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4438 0.835735C16.2871 0.678921 16.101 0.554524 15.8962 0.469652C15.6914 0.384779 15.4718 0.341095 15.2501 0.341095C15.0284 0.341095 14.8089 0.384779 14.6041 0.469652C14.3993 0.554524 14.2132 0.678921 14.0565 0.835735L8.89727 5.99386C8.79178 6.09931 8.64873 6.15855 8.49958 6.15855C8.35042 6.15855 8.20738 6.09931 8.10189 5.99386L2.94377 0.835735C2.62735 0.519166 2.19813 0.341259 1.75054 0.341154C1.30295 0.341048 0.873649 0.518752 0.55708 0.835172C0.240511 1.15159 0.0626055 1.58081 0.0625 2.0284C0.0623946 2.47599 0.240098 2.90529 0.556518 3.22186L5.71577 8.38111C6.0814 8.74678 6.51549 9.03685 6.99323 9.23476C7.47098 9.43266 7.98303 9.53452 8.50014 9.53452C9.01726 9.53452 9.52931 9.43266 10.0071 9.23476C10.4848 9.03685 10.9189 8.74678 11.2845 8.38111L16.4438 3.22186C16.7601 2.90541 16.9378 2.47626 16.9378 2.0288C16.9378 1.58133 16.7601 1.15219 16.4438 0.835735Z",
    fill: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBelow);
export default __webpack_public_path__ + "static/media/arrow_below.214e8597d1726155b6e6cd55ca384cbe.svg";
export { ForwardRef as ReactComponent };